<mat-toolbar color="primary" class="widget-toolbar">
    <span>Protocoles</span>
    <span class="toolbar-spacer"></span>
    <!-- <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>     -->
</mat-toolbar>
<div class="widget-table-container">
    <app-protocol-table [location]="'dashboard'" [paginator]="false" class="widget-content"></app-protocol-table>
</div>